// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData {
    static getAttributeTypeMap() {
        return TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData.attributeTypeMap;
    }
}
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData.discriminator = undefined;
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData.additionalProperties = false;
TenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData.attributeTypeMap = [
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
];
//# sourceMappingURL=tenantSiteAndPrescriberSiteAndPrescriberSearchSiteAndPrescriberSearchResponseData.js.map